// The interview consumes an array; the answer-specific callable returns one question.
export const createInterviewFollowup = (generateQuestion) => async ({ transcript, originalQuestion, previousQuestions = [] }) => {
  const result = await generateQuestion({
    transcript,
    originalQuestion: typeof originalQuestion === 'string' ? originalQuestion : originalQuestion?.text,
    previousQuestions,
  });
  const question = result.data?.question;
  if (!result.data?.success || typeof question !== 'string' || !question.trim()) {
    throw new Error('No follow-up question was returned. Please try again.');
  }
  return { data: { success: true, questions: [question.trim()] } };
};
